import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
import VideoModalButton from '../../components/video-modal-button';
$(() => {
    VideoModalButton.init();
    RevealWhenVisible.init();
    InlineVideo.init();
    ResponsiveVideo.init();
});
